import { useQuery } from "react-query";
import { fetchBirdsEyeViewData } from "./api";

export function useBirdsEyeView(filters, options={}) {
    return useQuery(["BirdsEyeViewData", filters], () => fetchBirdsEyeViewData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }